/** Empty clears the link, so it counts as valid. */
export function isValidLinkUrl(raw: string): boolean {
	if (!raw.trim()) return true
	return normalizeLinkUrl(raw) !== null
}

/**
 * Stored form of a link the user typed. Returns null for an empty field, which
 * clears the column, so a caller can pass the result straight to the mutator.
 */
export function normalizeLinkUrl(raw: string): string | null {
	const trimmed = raw.trim()
	if (!trimmed) return null
	const withProtocol = /^https?:\/\//i.test(trimmed)
		? trimmed
		: `https://${trimmed}`
	try {
		const url = new URL(withProtocol)
		if (!url.hostname.includes(".")) return null
		return url.toString()
	} catch {
		return null
	}
}
